import axios from "axios";
import { successHandling } from "../helpers/successHandling";
import {
  currentDateInUTC,
  scheduledDateInUTC
} from "../helpers/datetimeHandlers";
import { apiSelectedDeviceIdsHandler } from "../helpers/apiSelectedIdsHandler";

export const biosFwUpdateAPI = async (
  deviceId,
  devices,
  selectedDevicesIds,
  md5,
  fileName,
  filePath,
  executeType,
  datetime,
  commandText,
  t,
  successfulText
) => {
  let formData = new FormData();
  deviceId
    ? formData.append("device_id", deviceId)
    : apiSelectedDeviceIdsHandler(formData, devices, selectedDevicesIds); //single device or multiple devices
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("file_name", fileName);
  formData.append("file_path", filePath);
  formData.append("close_application_command", commandText);
  formData.append("md5", md5);

  await axios({
    url: `/api/v2/command/bios-firmware-update-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
